// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"BlogPop_ConfirmationPop__hBcr3","modalBody":"BlogPop_modalBody__0Xmrm"};